'use client';

import Link from 'next/link';
import { useLocale } from './use-locale';
import { type Locale } from './registry';
import { GameComponent } from './game-components';

const BACK_LABEL: Record<Locale, string> = {
  zh: '返回首页',
  en: 'Back',
};

/**
 * Client shell for `/play/[slug]`. Renders the floating back-to-home button
 * (bilingual) and the lazily-loaded game component. Slug validity is already
 * enforced server-side; the component trusts it.
 */
export function PlayShell({ slug }: { slug: string }) {
  const { locale } = useLocale();
  return (
    <main className="play-shell">
      <Link href="/" className="play-back-btn" aria-label={BACK_LABEL[locale]}>
        ← {BACK_LABEL[locale]}
      </Link>
      <GameComponent slug={slug} />
    </main>
  );
}
